export function buildQueryString<T>(filters: T): string {
  return (Object.entries(filters) as [keyof T, string | boolean | undefined][])
    .filter(([_, value]) => value !== undefined && value !== null)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(String(key))}=${encodeURIComponent(String(value))}`,
    )
    .join("&");
}
